<div class="row">
    <div [class.d-none]="countDown>0" class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div *ngIf="!isDone">
            <div class="d-flex justify-content-center mb-3">
                <div class="quiz-counter">
                    {{numberOfQuiz}} of {{totalQuiz}}
                </div>
            </div>
            <div class="progress mb-3">
                <div class="progress-bar" role="progressbar" [style.width]="percentQuiz+'%'"></div>
            </div>
            <div class="card bg-light text-dark rounded-5 mb-3">
                <div class="card-body text-center">
                    <div *ngIf="currentAnswer.length" class="text-center question d-flex align-items-center justify-content-center">
                        <h1 class="fw-bold" [style.color]="currentQuiz.color_code?.code">{{currentQuiz.color_name?.name}}</h1>
                    </div>
                </div>
            </div>
            <div *ngIf="currentAnswer.length" class="row d-flex flex-wrap justify-content-start">
                <div *ngFor="let a of currentAnswer" class="col-6 answer col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center mb-3">
                    <button class="btn btn-ls w-100 rounded-4 text-center text-dark h-100" (click)="answerQuiz(a)">
                        <h2 class="mb-0 p-0">
                            {{a.name}}
                        </h2>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="isDone" class="px-5">
            <app-finish [image]="graphImage" [point]="point" [time]="(elapsedTime/1000)" [title]="'Incongruent'"></app-finish>
        </div>
    </div>
    <div *ngIf="countDown>0 && !loading.status" class="col-12 text-center p-5">
        <h4>Ready?</h4>
        <h3>{{countDown}}</h3>
    </div>
</div>
